/* globals axios route */

import ErrorHandler from '../core/ErrorHandler';
import Multiselect from '../components/Multiselect.vue';

export default {
  props: {
    value: {},
    config: {
      type: Object,
      default: () => ({}),
    },
  },

  render(createElement) {

    // Remove the placeholder if the input is disabled.
    if (this.config.disabled) {
      this.defaults.placeholder = '';
    }

    const el = createElement(
      Multiselect, {
        props: {
          options: this.options,
          loading: this.loading,
          value: this.value,
          searchable: true,
          allowEmpty: false,
          internalSearch: false,
          ...this.defaults,
          ...this.config,
        },
        on: {
          'search-change': value => this.search(value),
          select: (selectedOption, id) => this.$emit('select', selectedOption, id),
          remove: (selectedOption, id) => this.$emit('remove', selectedOption, id),
          input: (value, id) => this.$emit('input', value, id),
        },
      },
    );

    el.data.scopedSlots = { ...el.data.scopedSlots, ...this.$scopedSlots };

    return el;
  },

  data() {
    return {
      route: '',
      loading: false,
      options: [],
      defaults: {},
    };
  },

  created() {
    this.search();
  },

  methods: {
    search(term = '') {
      this.loading = true;
      axios.get(`${route(this.route)}?search=${term}&sortName=asc`)
        .then(({ data }) => {
          this.loading = false;
          const defaultOptions = Object.prototype.hasOwnProperty.call(this.config, 'defaultOptions') ? this.config.defaultOptions : [];
          this.options = [...defaultOptions, ...data.data];
        })
        .catch(error => (new ErrorHandler(error)).dispatch());
    },
  },
};
